<script setup lang="ts">
import AppSearch from '@/components/AppSearch/AppSearch.vue';
import { LayoutGap } from '@dabble/quillui';
</script>

<template>
  <LayoutGap direction="column">
    <AppSearch url="/users/:id" index="users" />
  </LayoutGap>
</template>

<style lang="scss" scoped></style>
